import { createActionHandler, createReducer, OperationStatus } from '@pressreader/appstore';
import { IUserCollection } from '@pressreader/social-types';

import {
    loadUserCollectionsBegan,
    loadUserCollectionsCancelled,
    loadUserCollectionsDone,
    loadUserCollectionsFailed,
    resetUserCollectionsAction,
} from '../actions';

interface State {
    status: OperationStatus;
    userCollections: IUserCollection[];
}

const initialState: State = {
    status: OperationStatus.None,
    userCollections: [],
};

const reducer = createReducer(
    initialState,
    createActionHandler(loadUserCollectionsBegan, (state: State) => ({
        ...state,
        status: OperationStatus.Pending,
    })),
    createActionHandler(loadUserCollectionsDone, (state: State, { payload }) => ({
        ...state,
        status: OperationStatus.Done,
        userCollections: payload.collections,
    })),
    createActionHandler(loadUserCollectionsFailed, (state: State) => ({
        ...state,
        status: OperationStatus.Failed,
    })),
    createActionHandler(resetUserCollectionsAction, (state: State) => ({
        ...state,
        status: OperationStatus.None,
        userCollections: [],
    })),
    createActionHandler(loadUserCollectionsCancelled, (state: State) => ({
        ...state,
        status: OperationStatus.None,
    })),
);

export { reducer, State };
